export default __webpack_public_path__ + "static/media/add-wishlist-icon.5e07c5e3.svg";